var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManufacturinBillClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4413 26.0625C19.8963 26.0625 20.3327 26.2699 20.6544 26.6391C20.9762 27.0083 21.157 27.5091 21.157 28.0312C21.157 28.5534 20.9762 29.0542 20.6544 29.4234C20.3327 29.7926 19.8963 30 19.4413 30C18.9862 30 18.5499 29.7926 18.2281 29.4234C17.9063 29.0542 17.7256 28.5534 17.7256 28.0312C17.7256 27.5091 17.9063 27.0083 18.2281 26.6391C18.5499 26.2699 18.9862 26.0625 19.4413 26.0625ZM19.4413 9C19.709 8.9999 19.9682 9.10755 20.1739 9.30421C20.3795 9.50087 20.5186 9.77407 20.5668 10.0762L20.5851 10.3125V22.125C20.5856 22.453 20.4791 22.7693 20.2865 23.0117C20.0939 23.2541 19.8293 23.4049 19.5446 23.4345C19.26 23.4642 18.976 23.3704 18.7485 23.1718C18.5211 22.9732 18.3667 22.684 18.3158 22.3612L18.2975 22.125V10.3125C18.2975 9.9644 18.418 9.63056 18.6325 9.38442C18.847 9.13828 19.1379 9 19.4413 9Z",
    fill: "url(#paint0_linear_389_7934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23C30.6863 23 28 25.6863 28 29C28 32.3137 30.6863 35 34 35C37.3137 35 40 32.3137 40 29C40 25.6863 37.3137 23 34 23ZM29.9731 28.2978H38.0269V29.9132H29.9731V28.2978Z",
    fill: "url(#paint1_linear_389_7934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 19.5C37 9.83502 29.165 2 19.5 2C9.83502 2 2 9.83502 2 19.5C2 29.165 9.83502 37 19.5 37C21.745 37 23.8913 36.5772 25.8636 35.807",
    stroke: "url(#paint2_linear_389_7934)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_7934",
    x1: 19.4413,
    y1: 9,
    x2: 19.4413,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_7934",
    x1: 34,
    y1: 23,
    x2: 34,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_389_7934",
    x1: 19.5,
    y1: 2,
    x2: 19.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturinBillClock);
export default __webpack_public_path__ + "static/media/Manufacturin_Bill_clock.7beaf5649a3e2417c0e8619c32173680.svg";
export { ForwardRef as ReactComponent };